import { jsx as _jsx } from "react/jsx-runtime";
import styles from './DotPulse.scss';
export default function DotPulse({ size = 43, color = 'black', speed = 1.3, }) {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner, children: _jsx("div", { className: styles.dot }) }) }));
}
